/**************************************************************************************************/
/** @import Node Packages                                                                        **/
/**************************************************************************************************/
import { defineComponent } from 'vue'

/**************************************************************************************************/
/** @import Store/Global                                                                         **/
/**************************************************************************************************/
import Store from '@/Store/Global/Default'

/**************************************************************************************************/
/** @internal Const @name ModuleBox                                                              **/
/**************************************************************************************************/
const ModuleBox = defineComponent(
{
	/*************************************************/
	/** @Properties                                 **/
	/*************************************************/
	name: 'ModuleBox',

	props:
	{
		description: String,
		icon: String,
		path: String,
		title: String,
		viewProps: { type: Object, default: () => {} }
	},

	/*************************************************/
	/** @Data                                       **/
	/*************************************************/
	data()
	{
		return {
			isHovered: false
		}
	},

	/*************************************************/
	/** @Methods                                    **/
	/*************************************************/
	methods:
	{
		OnRedirectToModule() : void
		{
			const { viewMode } = Store.getters.getStoredViews
			this.$router.push({ name: this.path, params: { viewMode, ...this.viewProps } })
		}
	}
})

/**************************************************************************************************/
/** @export Component @name ModuleBox                                                            **/
/**************************************************************************************************/
export default ModuleBox

/**************************************************************************************************/
/** @export Type @name ModuleBoxRef                                                              **/
/**************************************************************************************************/
export type ModuleBoxRef = InstanceType<typeof ModuleBox>